<template>
  <div class="fichaje-container">

    <div class="header">
      <div class="left-section">
        <button @click="navigateTo('main')" class="btn-volver">
          <AppIcon :src="require('@/modules/working_hours/assets/keyboard_backspace.svg')" :size="29" class="icono-btn-secu" />
          Vista general
        </button>
        <h1 class="page-title">Historial de Fichajes</h1>
      </div>

      <div class="right-section">
        <button @click="navigateTo('main')" class="btn-primario">
          <AppIcon :src="require('@/modules/working_hours/assets/play_arrow.svg')" :size="29" class="icono-btn" />
          Fichar
        </button>

        <button
          @click="loadClocks"
          class="btn-primario btn-refresh"
          :disabled="screen_data.ui_loading"
        >
          <AppIcon :src="require('@/modules/working_hours/assets/refresh.svg')" :size="29" class="icono-btn" />
        </button>
      </div>
    </div>
    <hr class="header-separator" />

      <div class="acciones-secundarias">
        <button @click="navigateTo('absences')" class="btn-secundario-1">
          Ausencias
        </button>
        <button @click="navigateTo('history')" class="btn-secundario">
          Historial
        </button>
        <button @click="navigateTo('admin-month')" class="btn-secundario-1">
          Previsualización mes
        </button>
        <button @click="navigateTo('holidays')" class="btn-secundario-1">
          Vacaciones
        </button>
        <button
          v-if="canViewAdminButton"
          @click="navigateToAdmin"
          class="btn-secundario-1"
        >
          Admin
        </button>
      </div>
      <hr class="header-separator-1" />

    <div class="barra-lila">
      <div class="filtro-container">
        <div class="filtro-fechas">
          <label class="filtro-label">Desde:</label>
          <input
            type="date"
            v-model="filter.startDate"
            class="date-input"
          />

          <label class="filtro-label">Hasta:</label>
          <input
            type="date"
            v-model="filter.endDate"
            class="date-input"
          />
        </div>

        <div class="filtro-acciones">
          <button @click="applyFilter" class="btn-filter" :disabled="!filter.startDate || !filter.endDate">
            Aplicar filtro
          </button>

          <button
            v-if="canViewAdminButton"
            @click="openAdminClocksPopup"
            class="btn-admin-clocks"
          >
            <v-icon small color="white">mdi-plus-circle</v-icon>
            Gestionar fichajes
          </button>

          <button @click="clearFilter" class="btn-clear">
            Limpiar
          </button>

          <button
            @click="downloadFilteredCSV"
            class="btn-download"
            :disabled="filteredClocks.length === 0"
          >
            <v-icon small color="white">mdi-download</v-icon>
            Descargar CSV
          </button>
        </div>
      </div>
    </div> 

    <div class="marco-exterior">
    <div class="cuerpo-contenido">
      
      <update-clock-popup
        v-if="screen_data.update_clock_popup && screen_data.update_clock_popup.showed"
        :key="screen_data.update_clock_popup.clock_to_update ? screen_data.update_clock_popup.clock_to_update.uuid : 'nuevo'"
        :show="screen_data.update_clock_popup.showed"
        :clock="screen_data.update_clock_popup.clock_to_update"
        :errors="screen_data.update_clock_popup.errors"
        @close="close_update_clock_popup"
      />

      <div v-if="screen_data.ui_loading" class="text-center my-6">
        <v-progress-circular indeterminate color="primary" size="40" />
        <p class="mt-2">Cargando historial...</p>
      </div>

      <!-- Información de paginación -->
      <div v-if="!screen_data.ui_loading && filteredClocks.length > 0" class="pagination-info">
        Mostrando {{ startIndex + 1 }} - {{ endIndex }} de {{ filteredClocks.length }} fichajes
      </div>

      <transition-group name="fade" tag="ul" class="fichaje-list">
        <li
          v-for="clock in paginatedClocks"
          :key="clock.uuid"
          class="fichaje-item"
        >
          <div class="fichaje-item__content">
            <div>
              <div class="fichaje-linea1">Fecha: {{ formatDate(clock.timestamp) }}</div>
              <div class="fichaje-linea2">Tipo de acción: {{ formatType(clock.type) }}</div>
              <div v-if="hasPendingChange(clock)" class="pending-indicator">
                <v-chip color="purple" text-color="white" x-small>
                  <v-icon left x-small>mdi-clock-outline</v-icon>
                  Pendiente de aprobación
                </v-chip>
              </div>
            </div>

            <div class="acciones">
              <button
                class="boton boton-modificar"
                @click="handleUpdateClock(clock)"
                :disabled="hasPendingChange(clock)"
              >
                {{ hasPendingChange(clock) ? 'Solicitud enviada' : 'Modificar' }}
              </button>

              <button
                v-if="clock.changes && clock.changes.length > 1"
                class="boton-ver-cambios"
                :class="{ active: clock.ui_show_changes }"
                @click.stop="loader.toggle_show_changes(clock)"
              >
                <AppIcon :src="require('@/modules/working_hours/assets/arrow_drop_down.svg')" :size="29" class="{ rotated: clock.ui_show_changes }" />
              </button>
            </div>
          </div>

            <div v-if="clock.ui_show_changes" class="cambios-section">
              <div class="cambios-header">Historial de cambios</div>

              <ul class="cambios-lista">
                <li v-for="(cambio, index) in clock.changes" :key="index" class="cambio-item">
                  <div class="cambio-row">
                    <div class="cambio-info-izq">
                      <div class="cambio-fecha">
                        Fecha: {{ formatDate(cambio.timestamp) }}
                      </div>
                      <div class="cambio-tipo-label">
                        Tipo: {{ formatType(cambio.type) }}
                      </div>
                    </div>

                    <div class="cambio-estado">
                      <v-chip
                        :color="getChangeStateColor(cambio.state)"
                        text-color="white"
                        small
                      >
                        <v-icon left x-small>{{ getChangeStateIcon(cambio.state) }}</v-icon>
                        {{ getChangeStateText(cambio.state) }}
                      </v-chip>
                    </div>
                  </div>

                  <div v-if="cambio.justification" class="cambio-motivo-box">
                    <strong>Motivo:</strong> {{ cambio.justification }}
                  </div>

                  <div v-if="cambio.admin_uuid" class="cambio-admin-info">
                    <v-icon x-small color="green" class="mr-1">mdi-account-check</v-icon>
                    <span>Aprobado por admin</span>
                    <small v-if="cambio.fecha_aprobacion" class="ml-2">{{ formatDateTime(cambio.fecha_aprobacion) }}</small>
                  </div>
                </li>
              </ul>
            </div>
        </li>
      </transition-group>

      <!-- Controles de paginación -->
      <div v-if="!screen_data.ui_loading && filteredClocks.length > 0" class="pagination-controls">
        <div class="pagination-left">
          <label class="pagination-label">Elementos por página:</label>
          <select v-model.number="pagination.itemsPerPage" @change="pagination.currentPage = 1" class="pagination-select">
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>

        <div class="pagination-right">
          <button
            @click="previousPage"
            :disabled="pagination.currentPage === 1"
            class="pagination-btn"
          >
            <AppIcon :src="require('@/modules/working_hours/assets/keyboard_backspace.svg')" :size="29" class="pagination-icon" />
          </button>

          <span class="pagination-page-info">
            Página {{ pagination.currentPage }} de {{ totalPages }}
          </span>

          <button
            @click="nextPage"
            :disabled="pagination.currentPage === totalPages"
            class="pagination-btn"
          >
            <AppIcon :src="require('@/modules/working_hours/assets/keyboard_backspace.svg')" :size="29" class="pagination-icon rotate-180" />
          </button>
        </div>
      </div>

    </div>
  </div>

    <!-- Snackbar de confirmación -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="3000"
      bottom
      color="green"
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="adminClocksPopup.show"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="admin-popup-title">
          <span>Solicitar Nuevo Fichaje</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeAdminClocksPopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="admin-popup-content">
          <v-form ref="clockRequestForm" v-model="adminClocksPopup.formValid">
            <div class="form-field">
              <label class="form-label">Propuesta</label>
              <p class="form-hint">Fecha y hora del fichaje solicitado</p>
              <div class="datetime-row">
                <v-menu
                  v-model="adminClocksPopup.dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="adminClocksPopup.form.date"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      :rules="[v => !!v || 'La fecha es requerida']"
                      class="datetime-field"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="adminClocksPopup.form.date"
                    @input="adminClocksPopup.dateMenu = false"
                    locale="es"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="adminClocksPopup.timeMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="adminClocksPopup.form.time"
                      label="Hora"
                      prepend-icon="mdi-clock-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      :rules="[v => !!v || 'La hora es requerida']"
                      class="datetime-field"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="adminClocksPopup.form.time"
                    @click:minute="adminClocksPopup.timeMenu = false"
                    format="24hr"
                  ></v-time-picker>
                </v-menu>
              </div>
            </div>

            <div class="form-field">
              <label class="form-label">Jornada Registrada</label>
              <p class="form-hint">Tipo de acción a registrar</p>
              <v-select
                v-model="adminClocksPopup.form.type"
                :items="clockTypeOptions"
                item-text="label"
                item-value="value"
                outlined
                dense
                :rules="[v => !!v || 'El tipo es requerido']"
              ></v-select>
            </div>

            <!-- Campo: Comentario -->
            <div class="form-field">
              <label class="form-label">Comentario</label>
              <p class="form-hint">Justificación de la solicitud</p>
              <v-textarea
                v-model="adminClocksPopup.form.comment"
                outlined
                dense
                rows="3"
                placeholder="Explica el motivo de esta solicitud..."
                :rules="[v => !!v || 'El comentario es requerido']"
              ></v-textarea>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="admin-popup-actions">
          <v-btn text @click="closeAdminClocksPopup">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!adminClocksPopup.formValid || adminClocksPopup.loading"
            :loading="adminClocksPopup.loading"
            @click="submitClockRequest"
          >
            <v-icon left small>mdi-send</v-icon>
            Enviar Solicitud
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { APIClockRepository } from "@/modules/working_hours/infra/APIClockRepository";
import { UpdateClockCommand } from "@/modules/working_hours/app/UpdateClockCommand";
import { LoadHistory } from "@/modules/working_hours/app/LoadHistory";
import { VueWorkingHoursHistory } from "@/modules/working_hours/infra/VueWorkingHoursHistory";
import { UpdateClockPopup as UpdateClockPopupDomain } from "@/modules/working_hours/domain/UpdateClockPopup";
import UpdateClockPopup from "@/modules/working_hours/infra/UpdateClockPopup.vue";
import { formatTimestamp, formatClockType } from '@/modules/working_hours/domain/Utils';

export default {
  components: {
    UpdateClockPopup,
  },
  props: {
    companydb_id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      update_clock_cmd: null,
      screen_data: {
        clocks: [],
        update_clock_popup: null,
        ui_loading: false,
      },
      loader: null,
      filter: {
        startDate: '',
        endDate: '',
        active: false
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 25,
      },
      vueHistory: null, // Instancia para filtrado y paginación
      snackbar: {
        show: false,
        message: '',
        color: 'success'
      },
      adminClocksPopup: {
        show: false,
        formValid: false,
        loading: false,
        dateMenu: false,
        timeMenu: false,
        form: {
          date: '',
          time: '',
          type: '',
          comment: ''
        }
      },
      clockTypeOptions: [
        { value: 'in', label: 'Entrada' },
        { value: 'out', label: 'Salida' },
        { value: 'pause', label: 'Inicio Pausa' },
        { value: 'continue', label: 'Fin Pausa' }
      ],
      clockRepo: null
    };
  },
  async mounted() {
    this.screen_data.update_clock_popup = new UpdateClockPopupDomain();
    this.clockRepo = new APIClockRepository();
    this.loader = new LoadHistory(this.clockRepo, this.screen_data);

    // Configurar el comando de actualización con notificación por email a admins
    this.update_clock_cmd = new UpdateClockCommand(this.clockRepo, this.screen_data, {
      send_email_notification: true,
      getCompanyDbId: () => {
        const companyId = this.getCompanyId();
        return companyId ? parseInt(companyId) : undefined;
      }
    });

    // Inicializar el adaptador Vue para filtrado y paginación
    this.vueHistory = new VueWorkingHoursHistory(
      this.screen_data.clocks,
      this.filter,
      this.pagination
    );

    await this.loader.load();
  },
  computed: {
    filteredClocks() {
      if (!this.vueHistory) return this.screen_data.clocks;
      // Actualizar la referencia a clocks antes de filtrar
      this.vueHistory.updateClocks(this.screen_data.clocks);
      return this.vueHistory.getFilteredClocks();
    },

    canViewAdminButton() {
      const userData = this.$store.getters['me/userData'];
      if (!userData) return false;

      const userRole = userData.user_role ? userData.user_role.value : null;
      return userRole === 'owner' || userRole === 'admin' || userRole === 'customer';
    },

    totalPages() {
      return this.vueHistory ? this.vueHistory.getTotalPages() : 1;
    },

    startIndex() {
      return this.vueHistory ? this.vueHistory.getStartIndex() : 0;
    },

    endIndex() {
      return this.vueHistory ? this.vueHistory.getEndIndex() : 0;
    },

    paginatedClocks() {
      return this.vueHistory ? this.vueHistory.getPaginatedClocks() : [];
    }
  },
  methods: {
    getCompanyId() {
      return this.companydb_id || this.$route.params.companydb_id || (this.$store.getters["me/userData"] && this.$store.getters["me/userData"].company_id) || "1";
    },
    navigateTo(section) {
      const companyId = this.getCompanyId();
      const routes = {
        "main": `/${companyId}/working-hours`,
        "absences": `/${companyId}/working-hours-absences`,
        "holidays": `/${companyId}/working-hours-holidays`,
        "history": `/${companyId}/working-hours-history`,
        "admin-month": `/${companyId}/working-hours-admin-month`,
        "admin-users": `/${companyId}/working-hours-admin-users`
      };
      var result = this.$router.push(routes[section]);
      if (result && result.catch) {
        result.catch(function() {});
      }
    },
    navigateToAdmin() {
      // Todos (owner, admin, cliente) van a working-hours-admin-users
      this.navigateTo('admin-users');
    },
    async loadClocks() {
      await this.loader.load();
    },

    async reloadHistory() {
      await this.loader.load();
    },

    async handleUpdateClock(clock) {
      try {
        const saved = await this.update_clock_cmd.execute(clock);
        if (saved) {
          // Mensaje diferente según si es admin o nop
          // Para empleados normales, el cambio queda pendiente de aprobación
          this.snackbar.message = 'Solicitud de cambio enviada. Pendiente de aprobación por un administrador.';
          this.snackbar.color = 'success';
          this.snackbar.show = true;
        }
      } catch (error) {
        this.snackbar.message = 'Error al enviar la solicitud de cambio';
        this.snackbar.color = 'error';
        this.snackbar.show = true;
      }
    },
    hasPendingChange(clock) {
      // Verificar si el fichaje tiene alguna solicitud de cambio pendiente
      if (!clock.changes || clock.changes.length < 1) {
        return false;
      }
      return clock.changes.some(change =>
        change.state === 'pending' || change.state === 'pendiente'
      );
    },
    close_update_clock_popup(result) {
      this.screen_data.update_clock_popup.close(result);
    },
    formatDate(d) {
      return formatTimestamp(d);
    },
    formatType(type) {
      return formatClockType(type);
    },
    formatDateTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toLocaleString('es-ES');
    },
    getChangeStateColor(state) {
      const colors = {
        initial: 'grey',
        pendiente: 'purple',
        pending: 'purple',
        validada: 'green',
        validated: 'green',
        rejected: 'red',
        rechazada: 'red'
      };
      return colors[state] || 'grey';
    },
    getChangeStateText(state) {
      const texts = {
        initial: 'Original',
        pendiente: 'Pendiente',
        pending: 'Pendiente',
        validada: 'Aprobada',
        validated: 'Aprobada',
        rejected: 'Rechazada',
        rechazada: 'Rechazada'
      };
      return texts[state] || state;
    },
    getChangeStateIcon(state) {
      const icons = {
        initial: 'mdi-clock-outline',
        pendiente: 'mdi-alert-circle-outline',
        pending: 'mdi-alert-circle-outline',
        validada: 'mdi-check-circle',
        validated: 'mdi-check-circle',
        rejected: 'mdi-close-circle',
        rechazada: 'mdi-close-circle'
      };
      return icons[state] || 'mdi-circle';
    },
    applyFilter() {
      if (!this.vueHistory) return;

      const result = this.vueHistory.applyFilter();
      if (!result.success) {
        alert(result.error);
      }
    },

    clearFilter() {
      if (!this.vueHistory) return;
      this.vueHistory.clearFilter();
    },

    // Métodos de paginación
    nextPage() {
      if (this.vueHistory) {
        this.vueHistory.nextPage();
      }
    },

    previousPage() {
      if (this.vueHistory) {
        this.vueHistory.previousPage();
      }
    },

    openAdminClocksPopup() {
      this.adminClocksPopup.form = {
        date: '',
        time: '',
        type: '',
        comment: ''
      };
      this.adminClocksPopup.formValid = false;
      this.adminClocksPopup.loading = false;
      this.adminClocksPopup.show = true;
    },

    closeAdminClocksPopup() {
      this.adminClocksPopup.show = false;
      this.adminClocksPopup.loading = false;
    },

    async submitClockRequest() {
      if (!this.$refs.clockRequestForm.validate()) {
        return;
      }

      const userData = this.$store.getters['me/userData'];
      if (!userData || !userData.id) {
        this.snackbar.message = 'No se pudo identificar el usuario actual';
        this.snackbar.color = 'error';
        this.snackbar.show = true;
        return;
      }

      this.adminClocksPopup.loading = true;

      try {
        const [year, month, day] = this.adminClocksPopup.form.date.split('-');
        const [hours, minutes] = this.adminClocksPopup.form.time.split(':');
        const timestamp = new Date(year, month - 1, day, hours, minutes);

        const companyId = this.getCompanyId();

        await this.clockRepo.requestNew({
          user_id: userData.id,
          timestamp: timestamp,
          type: this.adminClocksPopup.form.type,
          justification: this.adminClocksPopup.form.comment,
          send_email_notification: true,
          companydb_id: companyId ? parseInt(companyId) : undefined
        });

        this.snackbar.message = 'Solicitud de fichaje enviada. Pendiente de aprobación.';
        this.snackbar.color = 'success';
        this.snackbar.show = true;

        this.closeAdminClocksPopup();

        await this.loadClocks();

      } catch (error) {
        console.error('Error al enviar solicitud:', error);
        this.snackbar.message = error.message || 'Error al enviar la solicitud de fichaje';
        this.snackbar.color = 'error';
        this.snackbar.show = true;
      } finally {
        this.adminClocksPopup.loading = false;
      }
    },

    async downloadFilteredCSV() {
      // Obtener el ID del usuario autenticado desde el store
      const userData = this.$store.getters['me/userData'];
      const userId = userData && userData.id;

      if (!userId) {
        alert('No se pudo identificar el usuario actual');
        return;
      }

      this.loading = true;

      try {
        const { sync_command_dispatcher } = await import('@/api/client');

        // Usar las fechas del filtro si está activo, sino usar todo el rango de clocks
        let startDate, endDate;
        if (this.filter.active && this.filter.startDate && this.filter.endDate) {
          startDate = this.filter.startDate;
          endDate = this.filter.endDate;
        } else {
          // Si no hay filtro, calcular el rango de todas las fechas disponibles
          if (!this.screen_data.clocks || this.screen_data.clocks.length === 0) {
            alert('No hay fichajes para descargar');
            return;
          }

          const dates = this.screen_data.clocks.map(c => new Date(c.timestamp));
          const minDate = new Date(Math.min(...dates));
          const maxDate = new Date(Math.max(...dates));
          startDate = minDate.toISOString().split('T')[0];
          endDate = maxDate.toISOString().split('T')[0];
        }

        const result = await sync_command_dispatcher.dispatch('generate_compliance_report', {
          admin_user_id: userId,
          employee_user_id: userId,
          start_date: startDate,
          end_date: endDate,
          format: 'csv'
        });

        const data = result.output || result;

        if (!data || !data.csv_data) {
          throw new Error('El backend no devolvió datos CSV');
        }

        const blob = new Blob([data.csv_data], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const filename = data.filename || (this.filter.active
          ? `informe_${startDate}_a_${endDate}.csv`
          : `informe_completo.csv`);

        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error('Error al descargar el CSV:', error);
        alert('Error al descargar el CSV: ' + error.message);
      } finally {
        this.loading = false;
      }
    }
  },

  watch: {
    companydb_id: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.$router.push({
          name: 'working-hours-history',
          params: { companydb_id: newVal }
        }).catch(() => {});
        // Recargar los datos con la nueva empresa
        if (this.loader) {
          await this.loader.load();
        }
      }
    }
  },
};
</script>

<style scoped>
.fichaje-container {
    padding: 12px;
    background-color: #ffffff;
    height: calc(100vh - 60px);
    align-items: center;
    flex-direction: column;
    overflow-x: hidden;
    display: flex;
    box-sizing: border-box;
    overflow-y: auto;
    border-radius: 20px 20px 0 0;
}

.btn-volver {
  display: flex;
  align-items: center;
  color: var(--Neutral-300, #B0B0B0);
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 4px;
  width: 400px;
  height: 16px;
  flex-shrink: 0;
}

.marco-exterior {
  padding: 16px;
  border-radius: 16px;
  width: 100%;
  max-width: 2000px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 4px;
}

.left-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 4px;
}

.page-title {
  margin-top: 2px;
  margin-left: 20px;
  font-size: 17px;
  font-weight: 600;
  color: var(--v-primaryDark-base);
}

.right-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-primario.btn-refresh {
  background: var(--Primary-700, #7339B7) !important;
  border: none;
  border-radius: 6px;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.btn-primario.btn-refresh:hover {
  background: #7a66d9;
}

.btn-primario.btn-refresh:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.fichaje-list {
  padding: 0;
  list-style: none;
  margin: 0;
}

.fichaje-item {
  display: flex;
  flex-direction: column;
  margin: 6px auto;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #888888;
  background: white;
  max-width: 900px;
  box-sizing: border-box;
  font-size: 0.85rem;
  gap: 0;
}

.fichaje-item__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fichaje-item__content > div:first-child {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.fichaje-item__fecha {
  font-weight: 600;
}

.fichaje-item__tipo {
  font-style: italic;
  opacity: 0.85;
}

.acciones {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 0;
}

.boton {
  padding: 6px 14px;
  font-size: 0.8rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1.2;
  white-space: nowrap;
}

.boton-modificar {
  display: flex;
  height: 26px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  background: var(--Neutral-100, #F3F3F3);
  min-width: 100px;
}

.boton-modificar:disabled {
  background: #E0E0E0;
  color: #999;
  cursor: not-allowed;
}

.pending-indicator {
  margin-top: 8px;
}

.boton-ver-cambios {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  padding: 4px;
  border-radius: 4px;
  background: var(--Neutral-100, #F3F3F3);
  border: none;
  margin-left: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.boton-ver-cambios:hover,
.boton-ver-cambios.active {
  background: var(--Neutral-200, #D1D1D1);
}

.boton-ver-cambios img {
  width: 18px;
  height: 18px;
  transition: transform 0.2s ease;
}

.boton-ver-cambios img.rotated {
  transform: rotate(180deg);
}

.cambios-section {
  margin-top: 12px;
  padding: 12px;
  background: var(--v-neutral-base);
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.cambios-header {
  color: #7339B7;
  text-align: left;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e0e0e0;
}

.cambios-lista {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cambio-item {
  padding: 10px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}

.cambio-row {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 12px;
  margin-bottom: 8px;
}

.cambio-info-izq {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  gap: 0;
}

.cambio-fecha {
  color: var(--Neutral-600, #565656);
  font-family: var(--Static-Title-Small-Font, Roboto);
  font-size: var(--Static-Title-Small-Size, 12px);
  font-style: normal;
  font-weight: 600;
  line-height: var(--Static-Title-Small-Line-Height, 18px);
  letter-spacing: var(--Static-Title-Small-Tracking, 0.1px);
  align-self: stretch;
}

.cambio-tipo-label {
  overflow: hidden;
  color: var(--Neutral-400, #888);
  text-overflow: ellipsis;
  font-family: Roboto;
  font-size: var(--Static-Label-Medium-Size, 12px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Static-Label-Medium-Line-Height, 16px); 
  align-self: stretch;
}

.cambio-motivo-box {
  background: #F0F0F0;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  color: #555;
  line-height: 1.5;
  border-left: 3px solid #d0d0d0;
}

.cambio-motivo-box strong {
  color: #333;
  font-weight: 500;
  margin-right: 8px;
}

.cambio-estado {
  flex-shrink: 0;
}

.cambio-admin-info {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding: 8px 10px;
  background: #f1f8f4;
  border-radius: 6px;
  border-left: 3px solid #4CAF50;
  font-size: 11px;
  color: #2e7d32;
}

.cambio-admin-info span {
  margin-right: 4px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.header-titulo {
  color: var(--Primary-950, var(--v-primaryDark-base));
  font-family: var(--font-family-text-font-display, Roboto);
  font-size: var(--font-size-text-size-title-h3, 16px);
  font-style: normal;
  font-weight: var(--font-weight-text-weight-bold, 700);
  line-height: var(--font-line-height-text-size-title-h3, 20px);
  letter-spacing: var(--font-letter-spacing-text-lineheight-heading, 0.5px);
}

.cuerpo-contenido {
  background-color: #ffffff;
  border-left: none;
  border-right: none;
  border-radius: 0px;
  padding: 16px 32px;
  margin-top: 0;
  width: 100%;
  box-shadow: none;
  flex: 1;
  box-sizing: border-box;
  max-width: 960px;
  margin: 0 auto;
}

.btn-secundario {
  display: flex;
  width: 150px;
  height: 26px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #D1D1D1);
  background: var(--Neutral-150, #E7E7E7);
  color: #333;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}

.btn-secundario-1 {
  display: flex;
  width: auto;
  height: 26px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #D1D1D1);
  background: var(--Neutral-150, #F3F3F3);
  color: #666;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-secundario-1:hover {
  background: #ECECEC;
}

.btn-primario {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-weight: 600;
  font-size: 11px;
  border: 1px solid var(--v-primary-base);
  background: #F9F6FE;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  height: 30px;
}

.btn-primario:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.icono-btn, .icono-btn-secu {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.barra-lila {
  width: 100%;
  padding: 10px 16px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--v-primaryLighter-base);
  border-left: 1px solid var(--Neutral-200, #D1D1D1);
  box-sizing: border-box;
  font-weight: 500;
  color: var(--v-primaryDark-base);
}

.acciones-secundarias {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  margin: 12px 0;
  padding: 0 12px;
  box-sizing: border-box;
}

.header-separator {
  width: 100%;
  border: none;
  border-top: 1px solid #ccc;
  margin: 0;
}

.header-separator-1 {
  width: 100%;
  border: none;
  border-top: 1px solid #ccc;
  margin: 0;
}

.fichaje-linea1 {
  width: 474px;
  color: var(--Neutral-600, #565656);
  font-family: var(--Static-Title-Small-Font, Roboto);
  font-size: var(--Static-Title-Small-Size, 13px);
  font-style: normal;
  font-weight: 600;
  line-height: var(--Static-Title-Small-Line-Height, 18px);
  letter-spacing: var(--Static-Title-Small-Tracking, 0.1px);
}

.fichaje-linea2 {
  width: 474px;
  overflow: hidden;
  color: var(--Neutral-400, #888);
  text-overflow: ellipsis;
  font-family: Roboto;
  font-size: var(--Static-Label-Medium-Size, 12px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Static-Label-Medium-Line-Height, 16px);
}

/* Estilos para el filtro */
.filtro-container {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.filtro-fechas {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.filtro-label {
  font-weight: 600;
  font-size: 11px;
  color: var(--v-primaryDark-base);
  white-space: nowrap;
}

.date-input {
  padding: 6px 10px;
  border: 1px solid #D1D1D1;
  border-radius: 6px;
  font-size: 11px;
  font-family: Roboto;
  background: white;
  cursor: pointer;
}

.date-input:focus {
  outline: none;
  border-color: var(--v-primary-base);
}

.filtro-acciones {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-filter,
.btn-clear,
.btn-download {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  border: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.btn-filter {
  background: var(--v-primary-base);
  color: white;
}

.btn-filter:hover:not(:disabled) {
  background: #4f2a7a;
}

.btn-filter:disabled {
  background: #B0B0B0;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-clear {
  background: #F3F3F3;
  color: #565656;
  border: 1px solid #D1D1D1;
}

.btn-clear:hover {
  background: #E7E7E7;
}

.btn-download {
  background: var(--v-primaryDark-base);
  color: white;
}

.btn-download:hover:not(:disabled) {
  background: #4f2a7a;
}

.btn-download:disabled {
  background: #B0B0B0;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-admin-clocks {
  background: #4CAF50;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  border: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.btn-admin-clocks:hover {
  background: #43A047;
}

/* Estilos para el popup de solicitud de fichaje */
.admin-popup-title {
  background: var(--v-primary-base);
  color: white;
}

.admin-popup-title .v-btn {
  color: white;
}

.admin-popup-content {
  padding: 16px;
}

.admin-popup-actions {
  padding: 12px;
  border-top: 1px solid #e0e0e0;
}

.form-field {
  margin-bottom: 12px;
}

.form-label {
  display: block;
  font-weight: 600;
  font-size: 12px;
  color: var(--v-primaryDark-base);
  margin-bottom: 4px;
}

.form-hint {
  font-size: 11px;
  color: #888;
  margin: 0 0 6px 0;
}

.datetime-row {
  display: flex;
  gap: 12px;
}

.datetime-field {
  flex: 1;
}

@media (max-width: 767px) {
  .fichaje-container {
    padding: 8px;
    height: 100vh;
  }

  .marco-exterior {
    padding: 10px;
    flex: 1;
    max-width: 100%;
  }

  .header-actions {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 8px;
  }

  .header-actions .btn-primario {
    flex: 1;
    margin: 0 4px;
  }

  .acciones-secundarias {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 8px;
  }

  .btn-secundario,
  .btn-secundario-1 {
    flex: 1;
    margin: 0 4px;
  }

  .fichaje-item {
    width: 100%;
    padding: 10px;
    margin-bottom: 8px;
  }

  .fichaje-item__content {
    flex-direction: column;
    gap: 6px;
  }

  .acciones {
    width: 100%;
    justify-content: space-between;
    gap: 6px;
    margin-top: 6px;
  }

  .boton-modificar {
    flex: 1;
  }

  .fichaje-linea1,
  .fichaje-linea2 {
    width: 100%;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .marco-exterior {
    padding: 14px;
  }

  .cuerpo-contenido {
    padding: 14px 20px;
  }

  .header-title {
    font-size: 1.1rem;
  }

  .fichaje-linea1,
  .fichaje-linea2 {
    width: 100%;
  }
}

@media (min-width: 1025px) {
  .header-actions {
    justify-content: flex-start;
    gap: 12px;
  }

  .acciones {
    gap: 12px;
  }
}

/* Estilos para la paginación */
.pagination-info {
  text-align: center;
  color: #565656;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 10px;
  padding: 6px;
}

.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding: 10px 16px;
  background: #F9F6FE;
  border-radius: 8px;
  border: 1px solid var(--v-primaryLighter-base);
}

.pagination-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--v-primaryDark-base);
}

.pagination-select {
  padding: 6px 10px;
  border: 1px solid #D1D1D1;
  border-radius: 6px;
  font-size: 11px;
  font-family: Roboto;
  background: white;
  cursor: pointer;
  min-width: 70px;
}

.pagination-select:focus {
  outline: none;
  border-color: var(--v-primary-base);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  padding: 6px;
  border: 1px solid #D1D1D1;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: #F3F3F3;
  border-color: var(--v-primary-base);
}

.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination-icon {
  width: 16px;
  height: 16px;
}

.pagination-icon.rotate-180 {
  transform: rotate(180deg);
}

.pagination-icon.double-arrow {
  opacity: 0.7;
}

.pagination-page-info {
  font-size: 11px;
  font-weight: 600;
  color: var(--v-primaryDark-base);
  min-width: 100px;
  text-align: center;
}

@media (max-width: 767px) {
  .pagination-controls {
    flex-direction: column;
    gap: 10px;
  }

  .pagination-left,
  .pagination-right {
    width: 100%;
    justify-content: center;
  }

  .pagination-page-info {
    font-size: 10px;
  }
}
</style>